// extracted by mini-css-extract-plugin
module.exports = {"sideLink":"SideLink_sideLink__5gH6t","sideLinkLeft":"SideLink_sideLinkLeft__MQ2gj","sideLinkIcon":"SideLink_sideLinkIcon__qdMrr"};